<template>
  <div class="tusd-wrap wrap-image login-register">
    <div class="login-register-header">
      <div class="logo"></div>
      <p>会员登录</p>
    </div>
    <div class="account-wrap reset-info">
      <div class="wrap-item">
        <span class="item-label phone-label">邮箱/手机号：</span>
        <input type="text"   v-model="login.phone" placeholder="请输入邮箱/手机号" />
      </div>
      <div class="wrap-item">
        <span class="item-label pw-label">密<i class="space one"></i>码：
        </span>
        <input type="password" maxlength="20" v-model="login.password" placeholder="请输入您的密码" />
      </div>
      <div class="tusd-btn login-register-btn" @click="goLogin">登录</div>
      <div class="forgot-register">
        <span @click="goPage('forgot')">忘记密码？</span>
        <!--  &nbsp;|&nbsp;&nbsp;<span @click="goPage('register')">注册</span> -->
      </div>
    </div>
    <!-- <div class="copyright">Copyright © {{year}} Company. All rights reserved.</div> -->
    <cube-popup type="prompt-popup" :mask="false" ref="promptPopup">{{ popupTxt }}</cube-popup>
  </div>
</template>

<script>
import api from "@/assets/api";
export default {
  name: "login",
  data() {
    return {
      year: new Date().getFullYear(),
      login: {
        phone: "",
        password: "",
        AccoutType: _ACCOUNTTYPY_
      },
      version: _AppVersion_,
      isWeb:_IsWeb_,
      appVersion: {},
      popupTxt: ""
    };
  },
  methods: {
    // _AppVersion_
    getAppVersion() {
      let that = this;
     
      that.$api.getAppVersion().then(resp => {
        that.$nextTick(() => {
          that.appVersion = resp.data;
          if (that.appVersion) {
            if (that.appVersion.NewVersion !== that.version) {
              //需要更新app
              //先弹出框再提示是不是要下载
              if (that.appVersion.IsMustUpdate) {
                //如果强制更新则直接更新
                that.downloadApp(that.appVersion.ApkUrl);
              } else {
                that.$message.confirm(
                  "提示",
                  "有新版本更新，是否需要升级？",
                  () => {
                    that.downloadApp(that.appVersion.ApkUrl);
                  }
                );
              }
            }
          }
        });
      });
    },
    downloadApp(url) {
      let that = this;
      plus.nativeUI.showWaiting("正在下载新版本，请稍等...");
      //创建下载管理对象
      var SX_down = plus.downloader.createDownload(url, {}, function(
        d,
        status
      ) {
        // 下载完成
        if (status == 200) {
          plus.nativeUI.closeWaiting();
          //下载成功后的回调函数
          plus.nativeUI.toast("下载成功，准备安装" + d.filename);
          plus.runtime.install(
            d.filename,
            {},
            function() {
              plus.nativeUI.toast("安装成功");
              plus.runtime.restart();
            },
            function(e) {
              plus.nativeUI.toast(d.filename + "安装失败");
              that.$message.popup(JSON.stringify(e), 1000);
            }
          );
        } else {
          that.$message.popup("下载失败:" + status, 1000);
        }
      });
      //开始下载任务
      SX_down.start();
    },
    goPage(name) {
      this.$store.commit("storeParams", {
        name: name,
        back: "login"
      });
      this.$router.push({ name: name });
    },
    goLogin() {
      let that = this;
      if (JSON.stringify(that.appVersion) !== '{}') {
        if (that.appVersion.NewVersion !== that.version) {
          if (that.appVersion.IsMustUpdate) {
            //如果强制更新则直接更新
            that.downloadApp(that.appVersion.ApkUrl);
          } else {
            that.$message.confirm(
              "提示",
              "有新版本更新，是否需要升级？",
              () => {
                that.downloadApp(that.appVersion.ApkUrl);
              }
            );
          }
        }
      }
      if (!that.login.phone) {
        that.common.showPopup(that, "请输入邮箱/手机号");
        return false;
      }
      // if (!that.verify.verifyPhone(that.login.phone)) {
      //   that.common.showPopup(that, "请输入正确的手机号");
      //   return false;
      // }
      if (!that.login.password) {
        that.common.showPopup(that, "请输入密码");
        return false;
      }
      if (!that.verify.verifyPassword(that.login.password)) {
        that.common.showPopup(that, "请输入至少6位字符");
        return false;
      }
      // if (that.appVersion) {
      //   if (that.appVersion.NewVersion !== _AppVersion_) {
      //     //需要更新app
      //     //先弹出框再提示是不是要下载
      //     that.$message.confirm("提示", "有新版本更新，是否需要升级？", () => {
      //       // that.common.showPopup(that, "升级完成");
      //       // 跳转到下载页面
      //       window.location.href = that.appVersion.ApkUrl;
      //     });
      //   }
      // }

      api.login(that.login).then(res => {
        let data = res.data;
        that.$store.commit("storeUserInfo", data);
        that.$store.commit("setParam", {
          name: "menu",
          prop: "active",
          value: "index"
        });
        that.$router.push({ name: "index" });
      });
    }
  },
  mounted() {
    
  },
  created() {
    if(this.isWeb!=1){
       this.getAppVersion();
    }
    this.$store.commit("logout");
  }
};
</script>
